import { Button } from "@progress/kendo-react-buttons";

interface GxHoldButtonProp {
  onClick: () => void;
  children?: string;
}

const GxHoldButton = ({ onClick, children }: GxHoldButtonProp) => {
  return (
    <Button
      onClick={onClick}
      className="gx-dialog-button-orange gx-submit-for-approval-small"
    >
      <span className="gx-h4-small">{children || ""}</span>
    </Button>
  );
};

export default GxHoldButton;
